/**
 * Client identity for a shared project link.
 *
 * There are no client accounts. Everyone on the client team opens the same
 * project URL; the only thing the Portal asks for is a name, so anything they
 * do can be attributed. That name is remembered in this browser and can be
 * changed if somebody else picks up the same computer.
 */

const NAME_KEY = 'portal.client.name'

export function loadClientName(): string {
  try {
    return window.localStorage.getItem(NAME_KEY)?.trim() ?? ''
  } catch {
    return ''
  }
}

export function saveClientName(name: string): void {
  try {
    window.localStorage.setItem(NAME_KEY, name.trim())
  } catch {
    /* Storage unavailable — the name simply lasts for this session. */
  }
}

export function clearClientName(): void {
  try {
    window.localStorage.removeItem(NAME_KEY)
  } catch {
    /* Nothing to clear. */
  }
}
